import { render, staticRenderFns } from "./NewSubscribers.vue?vue&type=template&id=10d187fa&"
import script from "./NewSubscribers.vue?vue&type=script&lang=js&"
export * from "./NewSubscribers.vue?vue&type=script&lang=js&"
import style0 from "./NewSubscribers.vue?vue&type=style&index=0&id=10d187fa&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10d187fa')) {
      api.createRecord('10d187fa', component.options)
    } else {
      api.reload('10d187fa', component.options)
    }
    module.hot.accept("./NewSubscribers.vue?vue&type=template&id=10d187fa&", function () {
      api.rerender('10d187fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/NewSubscribers.vue"
export default component.exports